// extracted by mini-css-extract-plugin
export default {"contextMenu":"table-context-menu_contextMenu__+wrl0"};